import React from "react";
import { useFormik } from "formik";

// A custom validation function. This must return an object
// which keys are symmetrical to our values/initialValues
const validate = (values) => {
  const errors = {};

  if (!values.OPT_IN) {
    errors.OPT_IN = "Required";
  }

  if (!values.FIRSTNAME) {
    errors.FIRSTNAME = "Required";
  } else if (values.FIRSTNAME.length < 3) {
    errors.FIRSTNAME = "Must be 3 characters or more";
  }

  if (!values.EMAIL) {
    errors.EMAIL = "Required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,5}$/i.test(values.EMAIL)) {
    errors.EMAIL = "Invalid email address";
  }

  return errors;
};

export const NewsletterFooterFormBrevo = ({ formID }) => {
  // Pass the useFormik() hook initial form values and a submit function that will
  // be called when the form is submitted
  const formik = useFormik({
    initialValues: {
      FIRSTNAME: "",
      EMAIL: "",
      OPT_IN: "",
      WEBSITE: "",
    },
    validate,
    // onSubmit: (values) => {
    //   alert(JSON.stringify(values, null, 2));
    // },
  });

  return (
    <>
      <div className="">
        <div className="">
          <form
            method="POST"
              action="https://a148f924.sibforms.com/serve/MUIFAGdmG2g7pY6JkLDlvxxIl8cTu3jIIusPJLuzvPTzwAmN-fktb4K-PhHoOnBxx9wfaBwK9uMiNFZfxUbRW86dmLFBGtFYdwBkos2QPw3fIPT0Qf7m3JNr19VVkbd630GeWo3ENPUg9-TKMph2aVFhc4dT18oB8ZKlnbv75xkjmLUh6WGTWbTllCVAhBucd6K_IlDZlv7yIglb"
            // noValidate
            // onSubmit={formik.handleSubmit}
          >
            <input
              type="text"
              name="email_address_check"
              value=""
              className="hidden"
            />
            <input type="hidden" name="locale" value="en" />
            <input type="hidden" name="html_type" value="simple" />
            <div className="grid grid-cols-12 gap-2">
              <div className="grid col-span-12 sm:col-span-7 lg:col-span-8 xl:col-span-9">
                <input
                  id="FIRSTNAME"
                  type="text"
                  name="FIRSTNAME"
                  className="pb-2 font-light text-white placeholder-novaPlaceholder bg-novaPurple border-b-2 input text-xl focus:outline-none focus:border-b-3 focus:placeholder:text-white"
                  placeholder="Your name"
                  aria-label="Your name"
                  required
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.FIRSTNAME}
                />
                {formik.touched.FIRSTNAME && formik.errors.FIRSTNAME ? (
                  <div className="pt-2 text-novaYellow font-bold text-sm">
                    {formik.errors.FIRSTNAME}
                  </div>
                ) : null}
              </div>

              <div className="grid col-span-12 sm:col-span-7 lg:col-span-8 xl:col-span-9 pt-2">
                <input
                  id="EMAIL"
                  type="email"
                  name="EMAIL"
                  className="pb-2 font-light text-white placeholder-novaPlaceholder bg-novaPurple border-b-2 input text-xl focus:outline-none focus:border-b-3 focus:placeholder:text-white"
                  placeholder="Your email"
                  aria-label="Your email"
                  required
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.EMAIL}
                />
                {formik.touched.EMAIL && formik.errors.EMAIL ? (
                  <div className="pt-2 text-novaYellow font-bold text-sm">
                    {formik.errors.EMAIL}
                  </div>
                ) : null}
              </div>
               <input
                  id="WEBSITE"
                  type="text"
                  name="WEBSITE"
                  className="hidden"
                  placeholder="website"
                  value=""
                />
              <div className="col-span-12 sm:col-span-5 lg:col-span-4 xl:col-span-3 pt-4 sm:pt-0 -mt-2 sm:mt-0">
                <button
                  type="submit"
                  aria-label='Submit newsletter form'
                  className="relative inline-flex items-center justify-center px-6 py-2 text-md overflow-hidden font-bold text-novaDarkGrey bg-novaYellow rounded-full group"
                >
                  <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-novaYellow2 rounded-full group-hover:w-56 group-hover:h-56"></span>
                  <span className="absolute inset-0 w-full h-full rounded-full"></span>
                  <span className="relative">Sign me up!</span>
                </button>
              </div>
              <div className="grid col-span-12">
                <div className="flex items-center">
                  <label
                    htmlFor="OPT_IN"
                    className="block pr-8 pt-2 text-xs font-light text-white"
                  >
                    Are you happy for us to contact you with this newsletter and
                    related information?
                  </label>
                  <label
                    htmlFor="OPT_IN"
                    className="block pr-2 ml-2 pt-2 text-sm font-light text-white"
                  >
                    Yes
                  </label>
                  <input
                    id="OPT_IN"
                    name="OPT_IN"
                    type="checkbox"
                    className="w-4 h-4 -mb-2"
                    required
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.GDPR}
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
